import { createSelector } from "reselect";

import { getRouteOperators } from "./state-accessors";

export const getProfileIdByOperatorId = createSelector(
  [getRouteOperators, (_: unknown, operator_id: string) => operator_id],
  (route_operators, operator_id) => {
    const profile_id = route_operators.find(
      o => operator_id === o.id
    )?.profile_id;
    return profile_id;
  }
);
